import { client } from '../lib/client';

// 제품이 어떤 차량에 적합할까? — 물품 설명 + 제품 사진(최대 3장) → 적합 차량·포장 권고 (조회 전용, 회원·비회원)
export const vehicleCheckAPI = (text, files = []) => {
  const fd = new FormData();
  fd.append('text', text || '');
  files.slice(0, 3).forEach((f) => fd.append('images', f));
  return client({ url: '/v1/ai/vehicle', method: 'post', data: fd, file: true }, true);
};

// 차량별 예상 운임·소요시간 — 접수 폼의 출발·도착·편도/왕복·급송 + 비교할 차량 이름들 (회원 전용)
export const vehicleCompareAPI = (body) => client({ url: '/v1/ai/vehicle/compare', method: 'post', data: body }, true);
